module.exports = __webpack_public_path__ + "img/tomasgonzalez.6c8c7e8d.jpg";